/*
 *    Copyright © 2020, Mirinae Corp. and John Wainwright
 */
import { createContext, useState } from 'react';

export const FeatureFlagContext = createContext();

// the analyzer redesign flag sticks in this browser once set by URL (?ff=mpc on, ?ff=mp off), so testers keep it across
//   reloads and links that don't carry ff=. Never on the production site, where a shared link must not opt people in.
export const CARDS_KEY = 'ff-analysisCards';
export const canStickFlags = () => typeof window !== 'undefined' && !/^(www\.)?mirinae\.io$/.test(window.location.hostname);
// RELEASE-BLOCK (Sean, 2026-10-07): the redesign is offered in the settings on test hosts only. Do not widen this to
//   release hosts until Sean says so in writing; isTestHost() is what keeps it off release even if this code ships there.
export const isTestHost = () => typeof window !== 'undefined' && /^(alpha\.|seoul\.|localhost$|127\.0\.0\.1$)/.test(window.location.hostname);
export const setCardsFlag = (setFlags, on) => {
    try { localStorage.setItem(CARDS_KEY, on ? '1' : '0'); } catch (e) { /* storage blocked */ }
    // drop ff= from the address too, or a reload would reapply it over this choice (urlParams.js)
    try {
        const url = new URL(window.location.href);
        if (url.searchParams.has('ff')) { url.searchParams.delete('ff'); window.history.replaceState(window.history.state, '', url); }
    } catch (e) { /* old browser: the choice still holds until the next ff= link */ }
    setFlags(prev => ({ ...prev, analysisCards: on }));
};
const stored = () => { try { return canStickFlags() && localStorage.getItem(CARDS_KEY) === '1'; } catch (e) { return false; } };

export function useFeatureFlags() {
    // set up feature-flag context
    const flagState = useState({
        // current feature flags
        endOfPagePapagoTranslation: false,
        multiLineInputArea: true, // in current branches, multi-line is now the only node supported (see tag Single-line-input for prior version)
        incrementalAnalysis: false,
        persistentInputText: true, // this is inactive for now, persistent by default
        displayAllParseTrees: false,
        analysisCards: stored(), // redesigned analyzer: phrase cards instead of the SVG tree
        // don't forget to add new ones to the encoder/decoder below

        // metaflag, causes above flag states to be added to page URL for forcing settings by URL
        addToURL: false, // for now, always on, seems the best way to make these states persistent
    });

    return flagState;
}